import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CustomModal from '../components/modal'
import ContactForm from './contact'
import HeroSection from '../components/HeroSection'
import ServicesSection from '../components/ServicesSection'
import SectorSection from '../components/SectorSection'
import PartnersSection from '../components/PartnersSection'
import OpenSourceSection from '../components/OpenSourceSection'
import MS365AlternativeSection from '../components/MS365AlternativeSection'
import HostingSection from '../components/HostingSection'
import CTASection from '../components/CTASection'
import WhyPathConnectSection from '../components/WhyPathConnectSection'
import Background from '../components/layout/background'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

const sectionSpacing = 'mt-12 lg:mt-20'
const firstSectionSpacing = 'mt-10 lg:mt-16'

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showScrollTop, setShowScrollTop] = useState(false)
  const [activeSection, setActiveSection] = useState('')
  const sectionRefs = useRef({})

  useEffect(() => {
    const sections = document.querySelectorAll('[data-section]')

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const sectionId = entry.target.getAttribute('data-section')
          if (entry.isIntersecting) {
            entry.target.classList.add('section-visible')
            setActiveSection(sectionId)
          } else {
            entry.target.classList.remove('section-visible')
          }
        })
      },
      { threshold: 0.3 }
    )

    sections.forEach((section) => {
      sectionObserver.observe(section)
    })

    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500)
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
      sectionObserver.disconnect()
    }
  }, [])

  const { t } = useTranslation('home')

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <Background>
      <CustomModal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
      >
        <ContactForm />
      </CustomModal>

      <button
        onClick={scrollToTop}
        className={`hidden sm:block fixed bottom-8 right-8 bg-primary/90 hover:bg-primary text-white rounded-full p-3 shadow-lg z-50 transition-all duration-500 ${showScrollTop ? 'opacity-100 scale-100' : 'opacity-0 scale-75 pointer-events-none'}`}
        aria-label="Back to top"
      >
        <FontAwesomeIcon icon={faArrowUp} className="text-lg" />
      </button>

      <section className="animate-section" data-section="hero">
        <HeroSection />
      </section>

      <section className={`animate-section ${firstSectionSpacing}`} data-section="ms365">
        <MS365AlternativeSection />
      </section>

      <section className={`animate-section ${sectionSpacing}`} data-section="services">
        <ServicesSection openContactModal={() => setIsModalOpen(true)} />
      </section>

      <section className={`animate-section ${sectionSpacing}`} data-section="why">
        <WhyPathConnectSection />
      </section>

      <section className={`animate-section ${sectionSpacing}`} data-section="sectors">
        <SectorSection />
      </section>

      <section className={`animate-section ${sectionSpacing}`} data-section="opensource">
        <OpenSourceSection />
      </section>

      <section className={`animate-section ${sectionSpacing}`} data-section="hosting">
        <HostingSection />
      </section>

      <section className={`animate-section ${sectionSpacing}`} data-section="partners">
        <PartnersSection />
      </section>

      <section className={`animate-section ${sectionSpacing}`} data-section="cta">
        <CTASection openContactModal={() => setIsModalOpen(true)} />
      </section>
    </Background>
  )
}

export default Home
